let baseURL: string

// Check the environment
if (false && process.env.NODE_ENV === 'production') {
	// Production environment
	baseURL = 'https://tikex.com/api'
} else {
	// Development environment
	baseURL = 'http://localhost:3000/api'
}

export function fetchWithBaseUrl(
	url: string,
	options: RequestInit = {}
): Promise<Response> {
	console.log('url: ', url)

	// Append the URL to the baseURL
	const fullUrl = `${baseURL}/${url}`

	// Make the fetch request
	return fetch(fullUrl, options)
}
